import ErrorComponent from '@mui/icons-material/Error';
import Warning from '@mui/icons-material/Warning';
import { AlertTooltip } from '@openx/components-core/lib/AlertTooltip/AlertTooltip.tsx';
import { type SeedListData, segmentSoonWillBeExpired, segmentStatus } from '@openx/types/segments.ts';

import { isSoonToDate } from '@openx/utils/lib/date.ts';

interface Props {
  segment: SeedListData;
}

const expiredText = 'Segment data is expired and cannot be used to refresh LAL Segments.';
const soonWillBeExpiredText = segmentSoonWillBeExpired(false);

export const SeedExpirationAlerts = ({ segment }: Props) => {
  const showExpiredSegmentAlert = segment.status === segmentStatus.EXPIRED;

  const showSegmentExpireSoonAlert = segment.status !== segmentStatus.EXPIRED && isSoonToDate(segment.expiration_date);

  if (!showExpiredSegmentAlert && !showSegmentExpireSoonAlert) {
    return null;
  }

  return (
    <>
      {showExpiredSegmentAlert && (
        <AlertTooltip
          color={theme => theme.palette.error.main}
          title={expiredText}
          icon={<ErrorComponent data-test="tooltip-alert-icon" fontSize="small" color="inherit" />}
        />
      )}
      {showSegmentExpireSoonAlert && (
        <AlertTooltip
          color={theme => theme.palette.warning.main}
          title={soonWillBeExpiredText}
          icon={<Warning data-test="tooltip-alert-icon" fontSize="small" color="inherit" />}
        />
      )}
    </>
  );
};
